import React from 'react';
import {Grid, Box, Typography} from '@mui/material';
import DevicesIcon from '@mui/icons-material/Devices';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SignalCellularOffIcon from '@mui/icons-material/SignalCellularOff';
import {EntioCard} from 'src/components/ui';
import {brand, semantic} from 'src/theme';

interface DeviceStatsCardProps {
  totalDevices: number;
  onlineDevices: number;
}

export default function DeviceStatsCard({totalDevices, onlineDevices}: DeviceStatsCardProps) {
  const offlineDevices = totalDevices - onlineDevices;

  const stats = [
    {
      icon: <DevicesIcon />,
      label: 'Total Devices',
      value: totalDevices,
      color: brand[500],
      bgColor: brand[100],
    },
    {
      icon: <SignalCellularAltIcon />,
      label: 'Online',
      value: onlineDevices,
      color: semantic.success.dark,
      bgColor: semantic.success.light,
    },
    {
      icon: <SignalCellularOffIcon />,
      label: 'Offline',
      value: offlineDevices,
      color: semantic.error.dark,
      bgColor: semantic.error.light,
    },
  ];

  return (
    <EntioCard>
      <Box
        sx={{
          p: {xs: 2, sm: 2.5},
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Grid
            container
            spacing={{xs: 1, sm: 2}}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {stats.map((stat, index) => (
              <Grid
                item
                xs={4}
                key={index}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: 'fit-content',
                  }}
                >
                  <Box
                    sx={{
                      width: {xs: 40, sm: 48},
                      height: {xs: 40, sm: 48},
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: stat.bgColor,
                      color: stat.color,
                      mb: 1,
                      '& svg': {
                        fontSize: {xs: 20, sm: 24},
                      },
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      mb: 0.5,
                      fontSize: {xs: '1rem', sm: '1.25rem'},
                      lineHeight: 1.2,
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      fontSize: {xs: '0.75rem', sm: '0.8rem'},
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </EntioCard>
  );
}
